import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';


@Component
export default class DashboardSidebar extends Vue {

  _goToHistory() {
    this.$router.push('/mi-menu/mi-historial')
  }
  _goToDashboard() {
    this.$router.push('/mi-menu/mi-dashboard')
  }
  _goToOrders() {
    this.$router.push('/mi-menu/mis-pedidos')
  }


  mounted() {
    let sideBar = document.querySelector('.side-bar');
    let arrowCollapse = document.querySelector('.arrow') as HTMLElement;
    let timesCollapse = document.querySelector('.times-button') as HTMLElement;

    sideBar.addEventListener('click', () => {

        sideBar.classList.toggle('collapse');
        arrowCollapse.classList.toggle('collapse');

        if (arrowCollapse.classList.contains('collapse')) {
            arrowCollapse.style.display = 'block';
            timesCollapse.style.display = 'none';
        } else {
            arrowCollapse.style.display = 'none';
            timesCollapse.style.display = 'block';
        }

    });
  }

}
